Object.defineProperty(exports, '__esModule', { value: true });

var tslib = require('tslib');
var React = require('react');
var components_baseToastPlate_component = require('../components/base-toast-plate/component.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

var styles = {"actionSection":"toast-plate__actionSection_1o8ud","title":"toast-plate__title_1o8ud","closeButtonWrapper":"toast-plate__closeButtonWrapper_1o8ud","closeButton":"toast-plate__closeButton_1o8ud"};
require('./desktop.css');

var ToastPlateDesktop = React.forwardRef(function (restProps, ref) { return React__default.default.createElement(components_baseToastPlate_component.BaseToastPlate, tslib.__assign({}, restProps, { styles: styles, ref: ref })); });

exports.ToastPlateDesktop = ToastPlateDesktop;
